import styled, { css } from 'styled-components';

export const ResultWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  ${props => props.isFav && css`
    flex-direction: row !important;
  `};
  ${props => props.isCorr && css`
    flex-direction: column !important;
  `};
`;

export const ResultLabel = styled.div`
  color: ${props => props.theme.colors[props.color]};
  font-size: 16px;
  margin: 3px 7px;
  ${props => (props.font) && css` 
    font-family: ${props.theme.fontSets[props.font]};
  `};
  ${props => (props.size) && css` 
    font-size: ${props.size} !important;
  `};
  ${props => props.theme.mediaQueries.tablet_big_down_team_next_widget}{
    font-size: 15px; 
  }
  ${props => props.customMargin && css`
     margin: ${props.customMargin};
  `};
  ${props => props.isMobile && css`
    font-size: 15px;
`};
`;



// WEBPACK FOOTER //
// ./src/components/TimeResults/Result/styles.js